import { Send } from "lucide-react";
import ModalBackButton from "../components/ModalBackButton";
import PaymentMethodButton from "../components/PaymentMethodButton";
import TransactionCheckoutHeader from "../components/TransactionCheckoutHeader";
import { useGlideDepositConfig } from "../lib/useDepositConfig";
import EVMWalletsLogo from "../logos/EVMWalletsLogo";
import CoinbaseLogo from "../logos/CoinbaseLogo";
import { PaymentMethod } from "./FundingSource";

type Props = {
  onSelect: (paymentMethod: PaymentMethod) => void;
  onBack: () => void;
  selectedPaymentMethod?: PaymentMethod;
};

export function CryptoFundingSource({
  onSelect,
  onBack,
  selectedPaymentMethod,
}: Props) {
  const depositConfig = useGlideDepositConfig();

  return (
    <>
      <ModalBackButton onClick={onBack} />

      <TransactionCheckoutHeader
        title={
          depositConfig.mode === "pay"
            ? "Pay with crypto"
            : (depositConfig.mode === "deposit" &&
                  depositConfig.hideSettlementCopy) ||
                !depositConfig.currency?.symbol
              ? "Deposit with crypto"
              : `Get ${depositConfig.currency.symbol}`
        }
      />

      <div className="space-y-3">
        {depositConfig.paymentMethods.includes("wallet") &&
        !depositConfig.excludeFundingSources?.includes("wallet") ? (
          <PaymentMethodButton
            icon={<EVMWalletsLogo className="h-8 w-8" />}
            title="Wallet"
            subtitle={"Connect your wallet and use any token"}
            onClick={() => onSelect("wallet")}
            loading={selectedPaymentMethod === "wallet"}
          />
        ) : null}
        {depositConfig.paymentMethods.includes("coinbase_app") &&
        !depositConfig.excludeFundingSources?.includes("coinbase_app") &&
        depositConfig.mode === "deposit" ? (
          <PaymentMethodButton
            icon={<CoinbaseLogo className="h-6 w-6 mx-1" />}
            title="Coinbase"
            subtitle={
              depositConfig.mode === "deposit"
                ? "Deposit from your Coinbase account"
                : "Transfer from your Coinbase account"
            }
            loading={selectedPaymentMethod == "coinbase_app"}
            onClick={() => onSelect("coinbase_app")}
            disabled={depositConfig.chain?.isTestnet}
          />
        ) : null}
        {depositConfig.paymentMethods.includes("transfer") &&
        !depositConfig.excludeFundingSources?.includes("transfer") ? (
          <PaymentMethodButton
            icon={<Send className="h-6 w-6 mx-1 text-indigo-400" />}
            title={
              depositConfig.mode === "deposit"
                ? "Deposit from anywhere"
                : "Transfer from anywhere"
            }
            subtitle={
              depositConfig.mode === "pay" || depositConfig.mode === "call"
                ? "Pay by transferring from other sources"
                : "Transfer from another wallet or exchange"
            }
            onClick={() => onSelect("transfer")}
            loading={selectedPaymentMethod === "transfer"}
          />
        ) : null}
      </div>
    </>
  );
}
